import type { FormLayout, FormLayoutPage } from '../../../../../forms'
import { BasicInfoLayout } from './basic-info'
import { buildLayoutWithCommonSections, layoutFields } from './helpers'
import { NotesLayout } from './notes'

const EscalatorLayout: FormLayoutPage = {
  key: 'escalator',
  title: 'Escalator',
  contents: [
    layoutFields.condition,
    layoutFields.accumulatedWear,
    layoutFields.design,
    layoutFields.inherentQuality,
    layoutFields.usage,
    layoutFields.environment,
    layoutFields.technology,
    layoutFields.drivingMachineInstallYear,
    layoutFields.operationalControllerInstallYear,
    layoutFields.typeOfMotorController,
    layoutFields.hasSeismicDevices,
    // TODO: Add missing step device
    // TODO: Add level step device
    layoutFields.hasCombImpactDetection,
    layoutFields.hasHandrailSpeedMonitoring,
    layoutFields.hasCeilingGuards,
    layoutFields.hasAntiSlideDevices,
    layoutFields.hasDriveChainDeviceSwitch,
    layoutFields.execSoftwareRevision,
    {
      ...layoutFields.drivingMachineManufacturerAndModel,
      label: 'Escalator Manufacturer - Model',
    },
  ],
}

export const EscalatorFormLayout: FormLayout = buildLayoutWithCommonSections([
  BasicInfoLayout,
  EscalatorLayout,
  NotesLayout,
])
